<template>
  <div id="wrapper">

    <router-view></router-view>

  </div>
</template>
<script setup>
</script>
<style>
:root {
  --font-size-small: 12px;
  --font-size-medium: 16px;
  --font-size-large: 20px;
  --current-font-size: var(--font-size-medium);
  /* 默认字号 */
}
</style>
